<template lang="pug">
  v-flex
    v-layout(column)
      span.mt-4.mb-2.subtitle-1.font-weight-bold.text-uppercase Preview
      v-layout(row)
        v-flex.preview(v-bind:style="{height: windowOffsetStyle}")
          img(:src="imageUrl" ref="preview" :width="width" :height="height" @load="onImageLoad")
      v-layout.px-3(row)
        v-flex.xs3.mr-5
          v-text-field.text-uppercase(type="number" min="0" :max="maxImageSideLength" label="width" :value="width" @input="setWidth")
        v-flex.xs3.mr-4
          v-text-field.text-uppercase(type="number" min="0" :max="maxImageSideLength" label="height" :value="height" @input="setHeight")
        v-flex.xs3.mt-2
          v-btn(@click='resetDimensions') Reset Image Size
</template>

<script>
export default {
  props: {
    windowOffset: {
      type: Number,
      default: 510,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    }
  },
  computed: {
    windowOffsetStyle() {
      return `calc(100vh - ${this.windowOffset}px)`;
    },
  },
  watch: {
    imageUrl() {
      this.clearDimensions();
    },
    selectedWidth() {
      this.$emit('update:width', this.selectedWidth);
    },
    selectedHeight() {
      this.$emit('update:height', this.selectedHeight);
    },
  },
  data() {
    return {
      maxImageSideLength: 9999,
      selectedWidth: null,
      selectedHeight: null,
    };
  },
  methods: {
    setWidth(value) {
      const image = this.$refs.preview;
      this.selectedWidth = Math.min(value, this.maxImageSideLength);
      this.selectedHeight = this.computeHeight(image, this.selectedWidth);
    },
    setHeight(value) {
      const image = this.$refs.preview;
      this.selectedHeight = Math.min(value, this.maxImageSideLength);
      this.selectedWidth = this.computeWidth(image, this.selectedHeight);
    },
    computeWidth(image, height) {
      return Math.round(height * image.naturalWidth / (image.naturalHeight || 1));
    },
    computeHeight(image, width) {
      return Math.round(width * image.naturalHeight / (image.naturalWidth || 1));
    },
    clearDimensions() {
      this.selectedWidth = null;
      this.selectedHeight = null;
    },
    resetDimensions() {
      this.selectedWidth = this.$refs.preview.naturalWidth;
      this.selectedHeight = this.$refs.preview.naturalHeight;
    },
    onImageLoad() {
      // Only reset on load if dimensions
      // not already set (i.e. new image load)
      if (!this.width && !this.height) {
        this.resetDimensions();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .preview {
    overflow: auto;
    border: solid 1px var(--v-background-lighten4);
    
    img {
      border: none;
    }
  }
</style>